/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_FailedInputs */

const en_us2_coach_failed = /** @type {(inputs: Coach_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This answer did not arrive in full.`)
};

const pt_br2_coach_failed = /** @type {(inputs: Coach_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta resposta não chegou inteira.`)
};

const es_419_coach_failed = /** @type {(inputs: Coach_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta respuesta no llegó completa.`)
};

const pt_pt2_coach_failed = /** @type {(inputs: Coach_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta resposta não chegou completa.`)
};

const fr_fr2_coach_failed = /** @type {(inputs: Coach_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette réponse n'est pas arrivée en entier.`)
};

const de_de2_coach_failed = /** @type {(inputs: Coach_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Antwort kam nicht vollständig an.`)
};

const it_it2_coach_failed = /** @type {(inputs: Coach_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa risposta non è arrivata per intero.`)
};

/**
* | output |
* | --- |
* | "This answer did not arrive in full." |
*
* @param {Coach_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_failed = /** @type {((inputs?: Coach_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_failed(inputs)
	if (locale === "es-419") return es_419_coach_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_failed(inputs)
	if (locale === "de-DE") return de_de2_coach_failed(inputs)
	if (locale === "it-IT") return it_it2_coach_failed(inputs)
	return en_us2_coach_failed(inputs)
});
export { coach_failed as "coach.failed" }